export default __webpack_public_path__ + "static/media/015-Corgi.cada8e76.svg";